import axios from "axios";
import { apiUrl, logApiError } from "@/shared/services/config.js";
import {
  OpenOrderDetailsDto,
  OrderDetailsResponse,
  PolicyInfoResponse,
} from "@/shared/dtos/index.js";

/**
 * POST /insured/submission — create a submission for an authenticated insured.
 * @returns {Promise<OpenOrderDetailsDto>}
 */
export const postInsuredSubmission = async (payload) => {
  try {
    const response = await axios.post(
      apiUrl("/insured/submission"),
      payload,
      { withCredentials: true },
    );
    return new OpenOrderDetailsDto(response.data);
  } catch (error) {
    logApiError(error);
    throw error;
  }
};

/**
 * GET /insured/order?submissionid= — full order details for a submission.
 * @returns {Promise<OrderDetailsResponse | null>}
 */
export const fetchInsuredOrderDetails = async (submissionId) => {
  try {
    const response = await axios.get(
      apiUrl("/insured/order"),
      { params: { submissionid: String(submissionId) }, withCredentials: true },
    );
    return response.data ? new OrderDetailsResponse(response.data) : null;
  } catch (error) {
    logApiError(error);
    throw error;
  }
};

/** @returns {Promise<PolicyInfoResponse | null>} */
export const fetchPolicyInfo = async (submissionId) => {
  try {
    const response = await axios.get(
      apiUrl("/insured/policy-info"),
      { params: { submissionid: String(submissionId) }, withCredentials: true },
    );
    return response.data ? new PolicyInfoResponse(response.data) : null;
  } catch (error) {
    logApiError(error);
    throw error;
  }
};
